"use client";

import Image from "next/image";

const logos = [
  { name: "Zillow", src: "/assets/logos/Edvive.svg" },
  { name: "Uber", src: "/assets/logos/LeKlub.svg" },
  { name: "NCR", src: "/assets/logos/Goldman-Sachs.svg" },
  { name: "Accenture", src: "/assets/logos/Y-Combinator.svg" },
  { name: "Triply", src: "/assets/logos/Triply.svg" },
  { name: "Skillophy", src: "/assets/logos/Skillophy.svg" },
  { name: "OneThread", src: "/assets/logos/OneThread.svg" },
  { name: "Yenex", src: "/assets/logos/Yenex.svg" },
  { name: "Ontik", src: "/assets/logos/Ontik.svg" },
  { name: "Sift", src: "/assets/logos/Sift.svg" },
  { name: "Tempo", src: "/assets/logos/Tempo.svg" },
  { name: "Ways", src: "/assets/logos/Ways.svg" },
];

const logosRow2 = [
  { name: "Backpack", src: "/assets/logos/Backpack.svg" },
  { name: "Relaxy", src: "/assets/logos/Relaxy.svg" },
  { name: "Addisoft", src: "/assets/logos/Addisoft.svg" },
  { name: "Ostad", src: "/assets/logos/Ostad.svg" },
  { name: "Rabfy", src: "/assets/logos/Rabfy.svg" },
  { name: "Oter", src: "/assets/logos/Oter.svg" },
  { name: "Memorybox", src: "/assets/logos/Memorybox.svg" },
  { name: "Zantrik", src: "/assets/logos/Zantrik.svg" },
  { name: "Likely", src: "/assets/logos/Likely.svg" },
  { name: "LendiView", src: "/assets/logos/LendiView.svg" },
  { name: "Banglashikhi", src: "/assets/logos/Banglashikhi.svg" },
  { name: "Edvive", src: "/assets/logos/Edvive.svg" },
];

function MarqueeRow({ items, reverse = false }: { items: typeof logos; reverse?: boolean }) {
  const doubled = [...items, ...items];

  return (
    <div className="overflow-hidden [mask-image:linear-gradient(to_right,transparent,black_10%,black_90%,transparent)] group">
      <div
        className={`${reverse ? "marquee-track-reverse" : "marquee-track"} group-hover:[animation-play-state:paused]`}
        style={{ "--marquee-duration": "20s" } as React.CSSProperties}
      >
        {doubled.map((logo, i) => (
          <div key={`${logo.name}-${i}`} className="flex-shrink-0 mx-4 sm:mx-6 md:mx-8 flex items-center justify-center h-8 w-20 sm:h-10 sm:w-24 md:h-12 md:w-28 opacity-100 hover:opacity-60 transition-opacity duration-300">
            <Image
              src={logo.src}
              alt={logo.name}
              width={112}
              height={48}
              className="object-contain theme-invert h-5 sm:h-6 md:h-8 w-auto"
            />
          </div>
        ))}
      </div>
    </div>
  );
}

export default function LogoMarquee() {
  return (
    <section className="py-7 relative z-[5]" style={{ background: "linear-gradient(180deg, rgba(225,29,36,0.06) 0%, rgba(225,29,36,0.02) 40%, var(--surface) 100%)" }}>
      {/* No heading — matches DM where logos scroll directly below hero green glow */}
      <div className="space-y-3 sm:space-y-4">
        <MarqueeRow items={logos} />
        {/* Second row hidden on phone — too cramped, one row is enough */}
        <div className="hidden sm:block">
          <MarqueeRow items={logosRow2} reverse />
        </div>
      </div>
    </section>
  );
}
